export default __webpack_public_path__ + "static/media/ninja.9b33724a.png";